import { Grid, Tag, Text } from '@wework/dieter-ui'

import React from 'react'
import { useSidebar } from '../../hoc/withSidebar'

export const getRoomLinkeageStatus = (space, noText = false) => {
  if (space.inventoryData && space.inventoryData?.relationships?.length > 0) {
    return (
      <Tag color="green" size="small">
        LINKED
      </Tag>
    )
  } else {
    return (
      <>
        {!noText ? (
          <Text style={{ fontSize: 14, lineHeight: '24px' }}>
            Select a room to link to this physical space so the map shows the
            right room.
          </Text>
        ) : null}
        <Tag color="red" size="small">
          NOT LINKED
        </Tag>
      </>
    )
  }
}

export default function LinkRoom({ space }) {
  const { openSideBar } = useSidebar()
  return (
    <Grid.Row>
      <Grid.Column width={8}>
        <Text style={{ fontSize: 16, fontWeight: 'bold' }}>Link inventory</Text>
        {getRoomLinkeageStatus(space)}
      </Grid.Column>
      <Grid.Column
        width={8}
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-end',
        }}
      >
        <Text
          style={{ fontSize: 14, cursor: 'pointer' }}
          primary
          onClick={() => openSideBar('Linkeage')}
        >
          Update{' >'}
        </Text>
      </Grid.Column>
    </Grid.Row>
  )
}
